<template>
  <v-card flat class="text-left">
    <div v-if="!user">
      Выберите пользователя организации
    </div>
    <v-list :color=" highlight ? 'yellow' : ''" v-else>
      <v-list-item three-line>
        <v-list-item-avatar>
          <v-img :src="getUserAvatar()"></v-img>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title > {{ user ? user.FIO : '' }}</v-list-item-title>
          <v-list-item-subtitle>{{ user ? user.EMP_WTITLE : '' }}</v-list-item-subtitle>
          <v-list-item-subtitle> {{ user ? user.ITP_NAME : '' }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <contactsLine :user="user" mode="view" @onContactSelected="exploreContact" />
      </v-list-item>
      <v-list-item v-if="mode=='operator'">
        <v-btn small :disabled="canSendCredentials" rounded color="teal" class="white--text" @click="sendCredentials"> Отправить данные для входа в ЛК</v-btn>
      </v-list-item>
    </v-list>
  </v-card>
</template>

<script>
// import editTxtField from '@/components/modules/org/structure/staff/fields/editTxtField.vue'

import { UI_SNACKBAR } from '@/store/actions/ui'
import { ORG_SEND_CREDENTIALS } from '@/store/actions/org'
export default {
  props: ['user', 'mode', 'highlight'],
  components: {
    contactsLine: () => import('@/components/modules/org/structure/staff/userContactsLine.vue')
  },
  data: () => ({

  }),
  computed: {
    canSendCredentials: {
      get: function () {
        if (!this.user) { return false }
        const mailIndex = this.user.CONTACTS.findIndex(item => item.CONT_TYPE === '0')
        const notUser = Number(this.user.USR_RECIPIENT) < 0 || Number(this.user.USR_ID) === -5
        return mailIndex === -1 || notUser
      }
    }
  },
  methods: {
    getUserAvatar () {
      /*
      var result = '/api/user/getPhoto.php?EMP_ID=' + this.user.EMP_ID
      if (this.user.INST_ID) {
        result = result + '&INST_ID=' + this.user.INST_ID
      }
      return result
    } */
      return '/static/images/user.png'
    },
    exploreContact (contact) {
      console.log('Contact selected', contact)
      if (contact.CONT_TYPE === '0') {
        window.open('mailto:' + contact.CONT_VALUE)
      }
    },
    sendCredentials () {
      this.$store.dispatch(ORG_SEND_CREDENTIALS, { EMP_ID: this.user.EMP_ID, INST_ID: this.user.INST_ID })
        .then(() => {
          console.log('Credentials sent success')
          this.$store.commit(UI_SNACKBAR, { color: 'green accent-4', text: 'Отправлено' })
        })
        .catch((err) => {
          console.log('Credentials sending error')
          this.$store.commit(UI_SNACKBAR, { color: 'red darken-1', text: 'Ошибка:' + err })
          console.log('Ошибка ', err)
        })
    }
  }
}
</script>
